// *******************************************************************************
// 1.0 - Filter
// *******************************************************************************

const modFilter = document.querySelector('.mod-filter');

// Open Filter
attachEvent('.mod-filter__trigger', 'click', () => {
  modFilter.classList.add('is-open-filter');
});

// Close Filter
attachEvent('.mod-filter__close', 'click', () => {
  modFilter.classList.remove('is-open-filter');
});

attachEvent('.mod-filter__overlay', 'click', () => {
  modFilter.classList.remove('is-open-filter');
});

// Close Filter When Escape Key Press
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && modFilter) {
    modFilter.classList.remove('is-open-filter');
  }
});
